import styled, { css } from 'styled-components';
import { Gray, White } from '../../colors';
const boxStyles = (isOpen) => css `
    ${BoxContainer} {
        visibility: ${isOpen ? 'visible' : 'hidden'};
        opacity: 1;
    }
`;
export const ButtonContainer = styled.div `
    width: 60px;
    display: flex;
    line-height: 20px;
    justify-content: flex-end;
`;
export const BoxContainer = styled.div `
    opacity: 0;
    display: flex;
    z-index: 2000;
    transition: 0.3s;
    position: absolute;
    visibility: hidden;
    border-radius: 4px;
    padding: 14px 20px;
    transform: translateY(-105%);
    border: 1px solid ${Gray.light};
    background-color: ${White.normal};

    box-shadow: -1px 9px 16px -2px rgba(0,0,0,0.21);
    -moz-box-shadow: -1px 9px 16px -2px rgba(0,0,0,0.21);
    -webkit-box-shadow: -1px 9px 16px -2px rgba(0,0,0,0.21);
`;
export const TooltipContainer = styled.div `
    position: relative;

    ${({ isOpen }) => boxStyles(isOpen)}
`;
//# sourceMappingURL=tooltip.styled.js.map